import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../Context/authContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, authReady } = useAuthContext();

    // Aguarda o carregamento da verificação do token
    if (!authReady) {
        console.log("Carregando");
        return <div>Carregando...</div>; // ou um Spinner
    }

    // Se autenticado, exibe o conteúdo protegido
    if (isAuthenticated) {
        return children;
    }

    // Se não autenticado, redireciona para o login    
    return <Navigate to="/Login" />;
};

export default PrivateRoute;
